/**
 * 将result.data同级数据挂载到result.data._meta上
 */
export function getMetaInfo(data) {
  return data?._meta;
}

export function isObject(obj) {
  let toStr = Object.prototype.toString;
  return toStr.call(obj) === '[object Object]';
}
